import { render, staticRenderFns } from "./npsDeclaration.vue?vue&type=template&id=dd157c74&scoped=true"
import script from "./npsDeclaration.vue?vue&type=script&lang=js"
export * from "./npsDeclaration.vue?vue&type=script&lang=js"
import style0 from "./npsDeclaration.vue?vue&type=style&index=0&id=dd157c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd157c74",
  null
  
)

export default component.exports